import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import LitImage from '../components/images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import { Link } from 'gatsby';
import useScreenSize from '../hooks/useScreenSize';

const SwitchSteps = ({
  introText,
  stepsData,
  introTextSecondary,
  mode,
  id,
  noSlider,
}) => {
  const screenSize = useScreenSize();

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    adaptiveHeight: true,
  };

  const stepCard =
    screenSize.width <= 900 ? (
      <Slider {...settings}>
        {stepsData?.map(
          (
            { number, icon, copy, heading, buttonPath, buttonText, image },
            index,
          ) => {
            return (
              <div className="switch-step-inner" key={index}>
                {number && <p className="switch-steps-number">{number}</p>}
                <LitImage image={icon ? icon : image} alt="steps icon" />{' '}
                {heading && (
                  <div className="switch-steps-header">
                    {heading.value ? (
                      <LitStructuredText data={heading} basic />
                    ) : (
                      heading
                    )}
                  </div>
                )}
                <p className="switch-steps-content">
                  {copy &&
                    (copy.value ? (
                      <LitStructuredText data={copy} basic />
                    ) : (
                      copy
                    ))}
                </p>
                {buttonText && <Link to={buttonPath}>{buttonText}</Link>}
              </div>
            );
          },
        )}
      </Slider>
    ) : (
      stepsData?.map(
        (
          { number, icon, copy, heading, buttonPath, buttonText, image },
          index,
        ) => {
          return (
            <div className="switch-step-inner" key={index}>
              {number && <p className="switch-steps-number">{number}</p>}
              <LitImage image={icon ? icon : image} alt="steps icon" />
              {heading && (
                <div className="switch-steps-header">
                  {heading.value ? (
                    <LitStructuredText data={heading} basic />
                  ) : (
                    heading
                  )}
                </div>
              )}
              <p className="switch-steps-content">
                {copy &&
                  (copy.value ? <LitStructuredText data={copy} basic /> : copy)}
              </p>
              {buttonText && <Link to={buttonPath}>{buttonText}</Link>}
            </div>
          );
        },
      )
    );

  return (
    <>
      {/* PurgeCSS include:  BlackMode, YellowMode, WhiteMode*/}
      <div className={`${mode}Mode`}>
        <div className={`switch-steps-container`} id={`${id}`}>
          {introText && (
            <div className="switch-steps-headers">
              {introText &&
                (introText.value ? (
                  <LitStructuredText data={introText} basic />
                ) : (
                  introText
                ))}
              {introTextSecondary && (
                <LitStructuredText data={introTextSecondary} basic />
              )}
            </div>
          )}

          <div className="switch-steps-inner-container">
            {noSlider
              ? stepsData?.map(
                  (
                    {
                      number,
                      icon,
                      copy,
                      heading,
                      buttonPath,
                      buttonText,
                      image,
                    },
                    index,
                  ) => {
                    return (
                      <div className="switch-step-inner" key={index}>
                        {number && (
                          <p className="switch-steps-number">{number}</p>
                        )}
                        <LitImage
                          image={icon ? icon : image}
                          alt="steps icon"
                        />
                        {heading && (
                          <div className="switch-steps-header">
                            {heading.value ? (
                              <LitStructuredText data={heading} basic />
                            ) : (
                              heading
                            )}
                          </div>
                        )}
                        <p className="switch-steps-content">
                          {copy &&
                            (copy.value ? (
                              <LitStructuredText data={copy} basic />
                            ) : (
                              copy
                            ))}
                        </p>
                        {buttonText && (
                          <Link to={buttonPath}>{buttonText}</Link>
                        )}
                      </div>
                    );
                  },
                )
              : stepCard}
          </div>
        </div>
      </div>
    </>
  );
};

export default SwitchSteps;
